import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'push',
      component: () => import('@/views/PushView.vue'),
    },
    {
      path: '/unsupported',
      name: 'unsupported',
      component: () => import('@/views/CompatibilityView.vue'),
    },
  ],
})

export default router
